import { Container } from 'react-bootstrap';
import { Title } from '../../components/Title/Title';
import { Topbar } from '../../components/Topbar/Topbar';
import { Footer } from '../../components/Footer/Footer';
import { TicketList } from '../../components/TicketList/TicketList';

const AdminTicketsComponent = () => (
  <>
    <Title>Tutti i ticket</Title>
    <Topbar />
    <Container className="my-5">
      <div className="display-4 mb-4">Tutti i ticket</div>
      <TicketList isAdmin />
    </Container>
    <Footer />
  </>
);

export default AdminTicketsComponent;
